import script from "./AssignmentDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssignmentDetails.vue?vue&type=script&setup=true&lang=ts"

import "./AssignmentDetails.vue?vue&type=style&index=0&id=9f01aeba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f01aeba"]])

export default __exports__